module.exports = __webpack_public_path__ + "img/14_2.35302d97.png";